var React = require('react');

function ArrowDownIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.5 1.5L8.5 8.5L15.5 1.5","stroke":"#29DDCC","strokeWidth":"3","strokeLinecap":"round"}));
}

ArrowDownIcon.defaultProps = {"width":"17","height":"11","viewBox":"0 0 17 11","fill":"none"};

module.exports = ArrowDownIcon;

ArrowDownIcon.default = ArrowDownIcon;
